import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Container, Row, Col } from 'react-bootstrap';

const SellTicketsManually = ({ onClick, hasEvents }) => (
    <Container>
        <Row>
            <Col lg={{ span: 10, offset: 1 }} md={12}>
                <div className='sell-tickets__header text-center'>
                    <h2 className="sell-tickets__header__1 d-inline-block">
                        <span className='sell-tickets-header__title'>
                            {hasEvents ? <FormattedMessage id='sell_tickets_manually_title_with_event'/>
                                : <FormattedMessage id='sell_tickets_manually_title_without_event'/>}
                        </span>
                    </h2>
                </div>
                {!hasEvents
                    && <div className="alert-no-events text-secondary border bg-body-tertiary  rounded p-3 mb-3">
                        <i className="bi bi-exclamation-circle me-2"></i> <FormattedMessage id="sell_no_events"/>
                    </div>
                }
                <div className="sell_tickets_manually__container border border-2 rounded p-5 text-center mb-3">
                    <div className="sell_tickets_manually__image border rounded-4">
                        <span></span>
                    </div>
                    <p className="mb-0"><FormattedMessage id='sell_tickets_manually_text'/> <FormattedMessage id='sell_tickets_manually_text_codes'/></p>
                    <Button variant='outline-primary' className="mt-3" onClick={onClick}>
                        <FormattedMessage id='add_tickets' />
                    </Button>
                </div>
            </Col>
        </Row>
    </Container>
);

export default SellTicketsManually;
